/**
 * Single source of truth for NAP + SEO (local + AI).
 * Keep identical across GBP, OTAs, Schema.org and page content.
 */
export const SITE_URL = 'https://www.czarna-owca.eu';

export const BUSINESS = {
  legalName: 'Agroturystyka Zacisze Czarna Owca',
  brandName: 'Zacisze Czarna Owca',
  alternateName: ['Czarna Owca', 'Pensjonat Czarna Owca', 'Agroturystyka Czarna Owca'],
  description:
    'Agroturystyka i pensjonat Zacisze Czarna Owca w Brzeżance koło Strzyżowa (Podkarpacie). Noclegi z basenem, sauną, jacuzzi, kortem tenisowym i salą balową — idealne na wypoczynek rodzinny, wesela i imprezy integracyjne blisko Rzeszowa.',
  shortDescription:
    'Noclegi agroturystyczne w Brzeżance koło Strzyżowa z basenem, sauną, jacuzzi i kortem tenisowym.',
  telephone: '+48791155235',
  telephoneDisplay: '+48 791 155 235',
  email: 'kontakt@czarnaowca.pl',
  priceRange: '180–1700 PLN',
  currenciesAccepted: 'PLN',
  paymentAccepted: ['Cash', 'Bank Transfer'],
  checkinTime: '14:00',
  checkoutTime: '11:00',
  address: {
    streetAddress: 'Brzeżanka 123',
    addressLocality: 'Brzeżanka',
    addressRegion: 'Podkarpackie',
    postalCode: '38-100',
    addressCountry: 'PL',
    cityForSearch: 'Strzyżów',
  },
  geo: {
    latitude: 49.841389,
    longitude: 21.771389,
  },
  areaServed: [
    'Brzeżanka',
    'Strzyżów',
    'Rzeszów',
    'Powiat strzyżowski',
    'Województwo podkarpackie',
    'Czarnorzecko-Strzyżowski Park Krajobrazowy',
  ],
  amenities: [
    'Basen zewnętrzny z brodzikiem',
    'Sauna',
    'Jacuzzi',
    'Kort tenisowy',
    'Sala balowa',
    'Sala gier (bilard, tenis stołowy, rzutki, piłkarzyki)',
    'Parking',
    'Duża przestrzeń na świeżym powietrzu',
  ],
  sameAs: [
    'http://www.czarna-owca.eu',
  ],
  rooms: [
    { name: 'Pokój dwuosobowy', occupancy: 2, price: 180 },
    { name: 'Pokój trzyosobowy', occupancy: 3, price: 250 },
    { name: 'Pokój czteroosobowy', occupancy: 4, price: 320 },
    { name: 'Pokój pięcioosobowy', occupancy: 5, price: 400 },
  ],
  exclusiveOffer: {
    name: 'Wyłączność całego obiektu — wieczór kawalerski / panieński',
    price: 1700,
    deposit: 1500,
  },
};

export const PAGES = {
  home: {
    path: '/',
    title: 'Zacisze Czarna Owca | Agroturystyka Brzeżanka koło Strzyżowa',
    description:
      'Agroturystyka Zacisze Czarna Owca w Brzeżance (38-100 Strzyżów). Noclegi z basenem, sauną, jacuzzi i kortem tenisowym. Rezerwacje: +48 791 155 235.',
    keywords:
      'agroturystyka Strzyżów, noclegi Brzeżanka, pensjonat Podkarpacie, Czarna Owca, basen sauna jacuzzi, noclegi koło Rzeszowa, wesela Strzyżów',
  },
  kontakt: {
    path: '/kontakt',
    title: 'Kontakt | Zacisze Czarna Owca — Brzeżanka 123, Strzyżów',
    description:
      'Skontaktuj się z agroturystyką Zacisze Czarna Owca. Adres: Brzeżanka 123, 38-100 Strzyżów. Tel. +48 791 155 235, e-mail: kontakt@czarnaowca.pl.',
    keywords: 'kontakt Czarna Owca, telefon agroturystyka Strzyżów, Brzeżanka 123',
  },
  galeria: {
    path: '/galeria',
    title: 'Galeria | Zacisze Czarna Owca — zdjęcia obiektu w Brzeżance',
    description:
      'Zdjęcia agroturystyki Zacisze Czarna Owca: basen, sauna, jacuzzi, kort tenisowy, sala balowa i teren wokół pensjonatu w Brzeżance koło Strzyżowa.',
    keywords: 'galeria Czarna Owca, zdjęcia pensjonat Strzyżów, basen Brzeżanka',
  },
  cennik: {
    path: '/cennik',
    title: 'Cennik noclegów | Zacisze Czarna Owca — od 180 zł',
    description:
      'Cennik pokoi w Zaciszu Czarna Owca: od 180 zł za pokój dwuosobowy. Wyłączność obiektu na imprezy od 1700 zł. Brzeżanka koło Strzyżowa.',
    keywords: 'cennik agroturystyka Strzyżów, ceny noclegów Brzeżanka, wynajem całego domku',
  },
  historia: {
    path: '/nasza_historia',
    title: 'Nasza historia | Zacisze Czarna Owca — agroturystyka na Podkarpaciu',
    description:
      'Poznaj historię pensjonatu Zacisze Czarna Owca w Brzeżance. Wypoczynek w ciszy Czarnorzecko-Strzyżowskiego Parku Krajobrazowego, blisko Strzyżowa i Rzeszowa.',
    keywords: 'historia Czarna Owca, agroturystyka Podkarpacie, Park Krajobrazowy Strzyżów',
  },
};

export const FAQ_ITEMS = [
  {
    question: 'Gdzie znajduje się Zacisze Czarna Owca?',
    answer:
      'Agroturystyka Zacisze Czarna Owca mieści się pod adresem Brzeżanka 123, 38-100 Strzyżów, w województwie podkarpackim. Obiekt leży około 5 km od Strzyżowa i w dogodnej odległości od Rzeszowa, w okolicach Czarnorzecko-Strzyżowskiego Parku Krajobrazowego.',
  },
  {
    question: 'Jakie atrakcje są dostępne na miejscu?',
    answer:
      'Goście mają do dyspozycji basen zewnętrzny z brodzikiem, saunę, jacuzzi, kort tenisowy, salę balową oraz salę gier z bilardem, tenisem stołowym, rzutkami i piłkarzykami. Teren oferuje dużo przestrzeni na świeżym powietrzu.',
  },
  {
    question: 'Ile kosztuje nocleg w Czarnej Owcy?',
    answer:
      'Ceny zaczynają się od 180 zł za pokój dwuosobowy, 250 zł za trzyosobowy, 320 zł za czteroosobowy i 400 zł za pięcioosobowy. Przy pobycie jednodniowym cena wzrasta o 10%.',
  },
  {
    question: 'Czy można wynająć cały obiekt na imprezę?',
    answer:
      'Tak. Możliwa jest organizacja wieczorów kawalerskich i panieńskich z wyłącznością całego domku. Cena za jednodniowy pobyt to 1700 zł plus kaucja 1500 zł. Obiekt nadaje się też na wesela, imprezy integracyjne i rodzinne urlopy.',
  },
  {
    question: 'Jak daleko jest do Rzeszowa i Strzyżowa?',
    answer:
      'Brzeżanka leży około 5 km od Strzyżowa. Do Rzeszowa jest ok. 40–55 km (lotnisko Rzeszów-Jasionka ok. 50–55 km). To dobra baza wypadowa na Podkarpacie i okolice Bieszczadów.',
  },
  {
    question: 'Jak zarezerwować pobyt?',
    answer:
      'Rezerwacji dokonasz telefonicznie pod numerem +48 791 155 235 lub mailowo: kontakt@czarnaowca.pl. Chętnie odpowiemy na pytania o dostępność, cennik i atrakcje.',
  },
  {
    question: 'Czy Zacisze Czarna Owca nadaje się na wypoczynek z dziećmi?',
    answer:
      'Tak. Obiekt ma basen z brodzikiem dla dzieci, salę gier i dużo przestrzeni na zewnątrz. To spokojne miejsce na rodzinny urlop z dala od zgiełku miasta.',
  },
  {
    question: 'Jakie są godziny zameldowania i wymeldowania?',
    answer:
      'Zameldowanie (check-in) od godziny 14:00, wymeldowanie (check-out) do godziny 11:00. Szczegóły pobytu warto potwierdzić przy rezerwacji.',
  },
];
